import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

/**
 * Generic datalayer for slide change events but not with next and prev buttons
 * @param {*} event
 * @param {*} swiper
 */

function dataLayerPushSlider(swiper, event) {
  const hasMoved = Math.abs(swiper.touches.diff) > 5;

  if (!swiper.isLocked && hasMoved && (event.type === 'touchend' || event.type === 'pointerup')) {
    const module = swiper.wrapperEl.closest('section');
    const title = module
      ? module.querySelector('[data-au-traction-calculator-table-title]') ||
        module.querySelector('[data-au-basic-map-distributor-title]') ||
        module.querySelector('[data-au-title]') ||
        module.querySelector('[data-au-heading-title]')
      : '';
    const titleText = title ? removeAccentMarkAndUppercase(title.innerText) : '';

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickSlider',
      item_id: titleText,
    });
  }
}

export default dataLayerPushSlider;
